"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EmailSentViewContainer = EmailSentViewContainer;
var _uiKit = require("@cian/ui-kit");
var React = _interopRequireWildcard(require("react"));
var _ViewContainer = require("../ViewContainer");
var _TitleContainer = require("../TitleContainer");
var _EmailSentInfo = require("../../components/EmailSentInfo");
var _sentEmail = require("../../types/sentEmail");
var _view = require("../../types/view");
var _events = require("../../types/events");
var _ContentLayout = require("../../components/ContentLayout");
var _tracking = require("../../utils/tracking");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function EmailSentViewContainer(_ref) {
  let {
    viewData,
    source,
    reset,
    changeLogin,
    emit,
    changeView
  } = _ref;
  const handleGotItClick = React.useCallback(() => {
    switch (viewData.type) {
      case _sentEmail.ESentEmailType.Restore:
        if (viewData.nextView) {
          changeView(viewData.nextView);
          break;
        }
        (0, _tracking.trackResetPasswordGotItClick)(source);
        reset();
        changeLogin(viewData.email);
        changeView(_view.EActiveView.AuthenticationRegistration);
        emit(_events.EEventType.EmailSentClosed, {
          type: _sentEmail.ESentEmailType.Restore
        });
        break;
      case _sentEmail.ESentEmailType.Registration:
        (0, _tracking.trackRegistrationDonePopupClose)(source);
        emit(_events.EEventType.EmailSentClosed, {
          type: _sentEmail.ESentEmailType.Registration
        });
        break;
    }
  }, [changeLogin, changeView, emit, reset, viewData.email, viewData.nextView, viewData.type, source]);
  React.useEffect(() => {
    if (viewData.type === _sentEmail.ESentEmailType.Registration) {
      (0, _tracking.trackRegistrationDonePopup)(source);
    }
  }, [viewData.type, source]);
  return /*#__PURE__*/React.createElement(_ViewContainer.ViewContainer, null, /*#__PURE__*/React.createElement(_TitleContainer.TitleContainer, null), /*#__PURE__*/React.createElement(_EmailSentInfo.EmailSentInfo, {
    viewData: viewData
  }), /*#__PURE__*/React.createElement(_ContentLayout.ContentLayout, null, /*#__PURE__*/React.createElement(_uiKit.Button, {
    "data-name": "GotItBtn",
    fullWidth: true,
    theme: "fill_primary",
    onClick: handleGotItClick
  }, "\u0425\u043E\u0440\u043E\u0448\u043E")));
}